import { PlatformType } from '../../types/action-types';
import GlobalECredentialsForm from './global-e-credentials-form';

interface IPlatformCredentialsFormProps {
    platform: PlatformType;
}

const PlatformCredentialsForm: React.FC<IPlatformCredentialsFormProps> = ({ platform }) => {
    switch (platform) {
        case PlatformType.GLOBAL_E:
            return <GlobalECredentialsForm />;
        default:
            return null;
    }
};

export default PlatformCredentialsForm;

